/**
 * Start a browser download from a short-lived signed URL (S3 presigned GET, or the local
 * driver's HMAC-signed route). The URL is never stored; it is used once and discarded.
 */
export function triggerDownload(url, fileName) {
  if (!url) return false;
  const a = document.createElement('a');
  a.href = url;
  if (fileName) a.download = fileName;
  a.rel = 'noopener';
  a.style.display = 'none';
  document.body.appendChild(a);
  a.click();
  setTimeout(() => a.remove(), 0);
  return true;
}

/** Save an in-memory Blob as a file (used for the audit CSV export). */
export function downloadBlob(blob, fileName) {
  const url = URL.createObjectURL(blob);
  triggerDownload(url, fileName);
  setTimeout(() => URL.revokeObjectURL(url), 10_000);
}
